export const PHONE = "+5491124908287";
export const PHONE_DISPLAY = "+54 9 11 2490-8287";
export const FACEBOOK_URL = "https://www.facebook.com/djesus.acosta";
export const INSTAGRAM_URL = "https://www.instagram.com/florentincontractors";
export const EMAIL = "florentincontractors@gmail.com";

export const WA_MESSAGE =
  "Hola! Vi su página web y me gustaría solicitar un presupuesto para un trabajo. ¿Podrían brindarme más información?";

export const waLink = (message = WA_MESSAGE) =>
  `https://wa.me/${PHONE.replace(/[^0-9]/g, "")}?text=${encodeURIComponent(message)}`;

export const COMPANY = {
  name: "Florentin Contractors",
  tagline: "Construcción • Refacciones • Pérgolas",
  subtitle:
    "Soluciones de construcción y remodelación con calidad, compromiso y atención personalizada.",
};
